var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"banner"},[(_vm.clientWidth > 768)?_c('img',{attrs:{"src":_vm.banner}}):_c('img',{attrs:{"src":_vm.banner_m}})]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module"},[_c('iframe',{attrs:{"src":"https://www.pailixiang.com/m/embedalbum_ia9936468925.html","frameborder":"0"}})])
}]

export { render, staticRenderFns }